const __request = require(`../../default/__request/__request_contentType_form`);
const r = function (pParameter) {
  if (!pParameter) pParameter = {};
  pParameter.appKey = `hotel`;
  return __request(pParameter);
};
module.exports = r;
